import { FileCopyOutlined } from '@mui/icons-material'
import Fab from '@mui/material/Fab'
import { motion } from 'framer-motion'
import { FolderCard } from '../folder-card'
import * as css from './style'
import { t } from '@lingui/core/macro'

interface TemplateType {
  id: number
  folder: {
    name: string
  }
  folder_id: number
}

interface Props {
  templates: Record<string, TemplateType[]>
}

const NoTemplatesFound = () => (
  <div css={css.divStyle}>
    <Fab css={css.fabStyle} disabled>
      <FileCopyOutlined css={css.fileCopyOutlinedIconStyle} />
    </Fab>
    <h3>{t`No templates found.`}</h3>
  </div>
)

export const TemplatesCard = ({ templates = {} }: Props) => {
  if (!templates || !Object.values(templates).length) return <NoTemplatesFound />

  return (
    <>
      {Object.values(templates).map((tmpl, i) => (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0, transition: { duration: 0.25, delay: i * 0.1 + 0.1 } }}
          key={`folder-card-${tmpl[0]?.folder_id || i}`}
        >
          <FolderCard templates={tmpl} folderName={tmpl[0]?.folder.name ?? ''} />
        </motion.div>
      ))}
    </>
  )
}
